import React, { useEffect, useState } from 'react';
import { useHUser } from '../hooks/HUsers';
import GRolesTable from '../../tables/GRolesTable';
import RoleForm from '../../dialogs/RoleForm';
import Button from '@mui/material/Button';

export default function RolesTab() {
    const {
        users,
        roles,
        rolesdesks,
        fetchRoles,
        fetchRolesDesks,
        handleRoleInsert,
        handleRoleDelete,
    } = useHUser();

    const [roleDialogOpen, setRoleDialogOpen] = useState(false);
    const [editingRole, setEditingRole] = useState<{ role: string; desks: string[] } | undefined>(undefined);
    const [editRow, setEditRow] = useState<number | null>(null);
    const [editValues, setEditValues] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        void fetchRoles();
        void fetchRolesDesks();
    }, [fetchRoles, fetchRolesDesks]);

    const handleAddRole = async (data: { role: string; desks: string }) => {
        try {
            await handleRoleInsert(data);
            await fetchRoles();
            await fetchRolesDesks();
            setRoleDialogOpen(false);
            setEditingRole(undefined);
        } catch (error) {
            console.error('Failed to add role:', error);
        }
    };

    const handleEditRole = (role: string, desks: string[]) => {
        setEditingRole({ role, desks });
        setRoleDialogOpen(true);
    };

    const handleDeleteRole = async (roleData: any) => {
        try {
            await handleRoleDelete({ email: roleData.role, role: roleData.role });
            await fetchRoles();
            await fetchRolesDesks();
        } catch (error) {
            console.error('Failed to delete role:', error);
        }
    };

    return (
        <div className='standard-div'>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className='standard-div-flex'>
                    <h1>Roles</h1>
                    <div className='header-flex'>
                        <Button variant='contained' color='primary' onClick={() => setRoleDialogOpen(true)}>
                            Add Role
                        </Button>
                    </div>
                    <RoleForm
                        open={roleDialogOpen}
                        onClose={() => { setRoleDialogOpen(false); setEditingRole(undefined); }}
                        onSubmit={handleAddRole}
                        initialRole={editingRole}
                    />
                </div>

                <div style={{ width: '100%' }}>
                    <GRolesTable
                        users={users}
                        roles={roles}
                        rolesdesks={rolesdesks}
                        editRow={editRow}
                        editValues={editValues}
                        setEditRow={setEditRow}
                        setEditValues={setEditValues}
                        handleEditSave={async () => setEditRow(null)}
                        handleEditRole={handleEditRole}
                        handleDelete={handleDeleteRole}
                    />
                </div>
            </div>
        </div>
    );
}
